import { API_BASE_URL } from './config';
import { authHeadersJson, clearStoredAccessToken } from './http';

export interface LoginPayload {
  email: string;
  password: string;
}

export interface LoginResponse {
  accessToken: string;
  userId: number;
  companyId: number;
  companyName: string;
  companySlug: string | null;
  email: string;
}

export interface MeResponse {
  userId: number;
  email: string;
  companyId: number;
  companyName: string;
  companySlug: string | null;
}

export const authApi = {
  login: async (payload: LoginPayload): Promise<LoginResponse> => {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      let message = 'No se pudo iniciar sesión';
      try {
        const body = (await response.json()) as { message?: string | string[] };
        if (typeof body.message === 'string') {
          message = body.message;
        } else if (Array.isArray(body.message)) {
          message = body.message.join(', ');
        }
      } catch {
        /* ignore */
      }
      throw new Error(message);
    }
    return response.json() as Promise<LoginResponse>;
  },

  me: async (): Promise<MeResponse> => {
    const response = await fetch(`${API_BASE_URL}/auth/me`, {
      headers: authHeadersJson(),
    });
    if (!response.ok) {
      clearStoredAccessToken();
      throw new Error('Sesión inválida');
    }
    return response.json() as Promise<MeResponse>;
  },
};
